import { useEffect, useRef, useState } from "react";
import {
  Link,
  Route,
  Routes,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import { useSelector } from "react-redux";
import Navigation from "../components/Navigation";
import NavigationBar from "../components/Navigation/NavigationBar";
import ChartPage from "./Chart";
import FormPage from "./Form";
import HistoryPage from "./History";
import HomePage from "./Home";
import LivePage from "./Live";
import logo from "../assets/images/logo-upordown_demo.png";
import useDeviceDetect from "../hook/useDeviceDetect";
import ClockTime from "../components/ClockTime";
import UserBalance from "../components/UserBalance";
import HowToPlay from "../components/HowToPlay";
import { ReactComponent as IconClose } from "../assets/images/icon-close.svg";
import { useTheme } from "../hook/useThemes";
import { getContestsCarousel } from "../redux/contests/selectors";
import Loading from "./Loading";
import { activeEventFathom } from "../utils/utils";
import FunMode from "../components/Navigation/FunMode";

const fathom = (window as any).fathom;

const DemoModal = () => {
  const modalRef = useRef<any>();
  const [open, setOpen] = useState(true);
  const auth = useSelector((state: any) => state?.auth);

  const handleBackdropClick = (e) => {
    fathom?.trackEvent("Demo - Outside Modal");
    if (
      modalRef.current &&
      e.target instanceof Element &&
      !modalRef.current.contains(e.target)
    ) {
      setOpen(false);
    }
  };

  const handleClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(false);
    fathom?.trackEvent(e.target.dataset.origin);
  };

  if (!open || !auth.demo) {
    return <></>;
  }

  return (
    <div className="demo-wrapper" onClick={handleBackdropClick}>
      <div className="demo-modal" ref={modalRef}>
        <a
          href=""
          className="close-btn"
          onClick={handleClose}
          data-origin="Demo - Close Btn"
        >
          <IconClose />
        </a>
        <div className="demo-title">Demo Version</div>
        <div className="demo-body">
          You are about to play the demo version of the game, to play with real
          money you need to login into your account.
        </div>
        <button
          className="demo-btn"
          onClick={handleClose}
          data-origin="Demo - Start Btn"
        >
          START
        </button>
      </div>
    </div>
  );
};

export default function Main() {
  const { pathname } = useLocation();
  const { isTablet, isMobile } = useDeviceDetect();
  const { settingImage } = useTheme();

  const [query, setQuery] = useState("");

  const [searchParams] = useSearchParams();
  const demo = searchParams.get("demo") === "true";

  const dataList = useSelector(getContestsCarousel);

  useEffect(() => {
    const operatorId = searchParams.get("theme");
    const langParam = searchParams.get("lang");
    const demo = searchParams.get("demo");

    const newQuery = `?demo=${demo}&theme=${operatorId}&lang=${langParam}`;
    setQuery(newQuery);
  }, [searchParams]);

  const [number, setNumber] = useState<number>(0);
  const [iShowCard, setIShowCard] = useState<boolean>(false);

  const refNumber = useRef<any>(0);

  useEffect(() => {
    const timeInterVal = dataList?.length ? 10 : 100;
    const interval = setInterval(() => {
      if (refNumber.current >= 99) {
        window.clearInterval(interval);
        return;
      }
      refNumber.current += 1;
      setNumber((number) => number + 1);
    }, timeInterVal);

    if (iShowCard) {
      window.clearInterval(interval);
    }

    return () => {
      window.clearInterval(interval);
    };
  }, [dataList, iShowCard]);

  useEffect(() => {
    if (dataList.length) {
      setTimeout(() => {
        setIShowCard(true);
      }, 500);
    }
    if (number >= 100) {
      setTimeout(() => {
        setIShowCard(true);
      }, 500);
    }
  }, [number, dataList]);

  return (
    <>
      <div
        className="wrap-content-page"
        style={{
          opacity: iShowCard ? 1 : 0,
          zIndex: iShowCard ? 2 : -1,
        }}
      >
        {/* <DemoModal /> */}
        <Navigation />
        {/* <div className="wrapper-NavigationBar-mobile">
        <NavigationBarMobile />
      </div> */}
        {isTablet && (
          <div
            className="wrapper-logo"
            style={{
              backgroundImage: `url(${
                isMobile ? settingImage.bg_header_mobile : settingImage.bg_header
              })`,
            }}
          >
            <UserBalance />
            <Link
              to={`/${window.location.search}`}
              onClick={() => activeEventFathom("Menu-Logo")}
              className="wrap-logo"
            >
              <img src={settingImage?.logo || logo} className="logo" alt="" />
              {demo && <FunMode />}
            </Link>
            <ClockTime />
          </div>
        )}

        <div className="wrapper-content-routes">
          <Routes>
            <Route path="/live" element={<LivePage />} />
            <Route path="/chart" element={<ChartPage />} />
            <Route path="/results" element={<FormPage />} />
            <Route path="/history" element={<HistoryPage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
          {(pathname === "/" || !pathname) && (
            <div className="wrapper-component-how-to-play">
              <HowToPlay />
            </div>
          )}
        </div>

        <div className="wrapper-NavigationBar">
          {pathname !== "/" && <NavigationBar />}
          {/* {pathname === "/history" && <BalanceMobile />} */}
        </div>
      </div>

      <div
        className="wrap-loading"
        style={{
          opacity: !iShowCard ? 1 : 0,
          zIndex: !iShowCard ? 2 : -1,
        }}
      >
        <Loading number={number} />
      </div>
    </>
  );
}
